import { createSlice } from "@reduxjs/toolkit";

/**
 * core.signIn - Sign In 関連のデータ
 * core.apiUnauthorized - API 利用時に 401 Unauthorized が発生した
 */
const core = createSlice({
  name: "Core",
  initialState: {},
  reducers: {
    /**
     * Sign In 画面に到着した
     */
    arrivedSignIn(state) {
      state.signIn = state.signIn || {};
      state.signIn.inScreen = true; // Sign In 画面にいる

      // 認証エラーによるリダイレクト設定を解除する
      state.apiUnauthorized = state.apiUnauthorized || {};
      state.apiUnauthorized.redirectToSignIn = false; // リダイレクトを解除
    },

    /**
     * Sign In 画面を離れた
     */
    leftSignIn(state) {
      state.signIn = state.signIn || {};
      state.signIn.inScreen = false; // Sign In 画面にいない
    },

    /**
     * API 実行で認証エラーが発生した
     */
    happenedApiUnauthorized(state, action) {
      state.signIn = state.signIn || {};

      // Sign In 画面以外で認証エラーが発生した場合はリダイレクトを指定する
      if (!state.signIn.inScreen) {
        state.apiUnauthorized = state.apiUnauthorized || {};
        state.apiUnauthorized.redirectToSignIn = true; // リダイレクトを要請
      }
    },
  },
});

const { reducer } = core;
export const { actions } = core;
export default reducer;
